import { Sidebar } from '@kl/components-v6';
import { LocalizedHeading } from 'shared/ui/localized-heading';
import styled from 'styled-components';

export const StyledLicenseAgreementsContainer = styled.div<{
    height?: string;
}>`
    display: flex;
    max-width: 1098px;
    margin: 0 auto;
    flex-direction: column;
    padding: 24px;
    gap: 20px;
    height: ${({ height }) => (height ? height : 'auto')};
`;

export const StyledContentWrapper = styled.div`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;

    p,
    div,
    li,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        color: var(--text--primary);
    }
`;

export const StyledTextContainer = styled.div<{
    padding?: string;
}>`
    p,
    div,
    li,
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        color: var(--text--primary);
    }

    height: 100%;
    padding: ${({ padding }) => (padding ? padding : '0')};
`;

export const StyledSidebar = styled(Sidebar)`
    & .antd-sidebar-content {
        height: 100%;
    }
`;

export const StyledLocalizedHeading = styled(LocalizedHeading)`
    max-width: 800px;
`;
